<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <non-trend-chart ref="chartInstance"
                         class="widget-contents-chart"
                         :type="opts.chartType"
                         :x-axis="xAxis"
                         :y-axis="yAxis"
                         :legend="false"
                         :tooltip="toolTip"
                         :series="stackSeries"
                         :data="allowWidgetData"
                         :seriesOptions="seriesOptions"
        />
      </div>
    </div>
  </div>
</template>
<script>
// Mixin 객체
import {widgetMixin} from '~/mixins/widgetCommonMixin'

// 스토어 헬퍼
import {createNamespacedHelpers} from 'vuex'

// 스토어 헬퍼 객체
const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

export default {
  name: 'widgetFwAllowTop10',
  directives: {},
  mixins: [widgetMixin],
  data () {
    return {
      w: 2,
      opts: {
        chartType: 'column'
      },
      title: 'widgetFwAllowTop10',
      categories: [], // TAMS
      isLock: false,
      isMove: true,
      isResize: true,
      eventBus: true,
      deviceType: [20],
      // isIpType: true,
      restData: {
        result: [],
        unit_time: ''
      },
      seriesOptions: {
        barWidth: '40%'
      },
      stackSeries: [
        {
          type: 'bar',
          name: 'IPv4',
          stack: 'total',
          animation: false,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0,0,0,0.3)'
            }
          }
        },
        {
          type: 'bar',
          name: 'IPv6',
          stack: 'total',
          animation: false,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0,0,0,0.3)'
            }
          }
        }
      ],
      widgetData: [],
      allowWidgetData: [[], []]
    }
  },
  props: {},
  computed: {
    xAxis () {
      const xAxisOptions = {}

      if (this.opts.chartType === 'bar') {
        xAxisOptions.axisLabel = {
          formatter: (value) => {
            return `${this.byteConverter(value)}`
          }
        }
      }
      if (this.opts.chartType === 'column') {
        xAxisOptions.data = this.categories
      }
      return xAxisOptions
    },
    yAxis () {
      const yAxisOptions = {}

      if (this.opts.chartType === 'column') {
        yAxisOptions.axisLabel = {
          formatter: (value) => {
            return `${this.byteConverter(value)}`
          }
        }
      }
      if (this.opts.chartType === 'bar') {
        yAxisOptions.data = this.categories
      }
      return yAxisOptions
    },
    toolTip () {
      return {
        formatter: (params) => {
          let resFormat = ''
          for (let i = 0; i < params.length; i++) {
            if (params[i].value > 0) {
              const count = Math.abs(params[i].value)
              resFormat = `${params[i].marker}${params[i].name} : <b>${this.byteConverter(count)}${this.restData.unit_time}</b>`
            }
          }

          return resFormat
        }
      }
    },
    widgetChartMenu () {
      return [
        {
          icon: 'icon-chart-bar',
          label: 'Bar Chart',
          value: 'bar'
        },
        {
          icon: 'icon-chart-column',
          label: 'Column Chart',
          value: 'column'
        }
      ]
    }
  },
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  activated () {},
  deactivated () {},
  beforeDestroy () {},
  destroyed () {},
  errorCaptured () {},
  methods: {
    ...mapActions([
      'getWidgetData'
    ]),
    // 위젯 대상 장비 필터 설정.
    async onChangeWidgetMachId ({machId}) {
      // 위젯 옵션 변경 - 저장에 필요한 값???
      this.opts.mach_id = machId
      this.getWidgetContentsData(true, machId)
    },
    async getWidgetContentsData (init = false, extraParams = null) {
      const contentsOptions = {}

      // 장비 filter 추가
      if (this.opts.mach_id) {
        contentsOptions.machId = this.opts.mach_id
      }

      // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
      if (extraParams && extraParams.machId) {
        contentsOptions.machId = extraParams.machId
      }

      // Progress 출력 여부
      this.showProgress(true)

      // initFlag가 True면 기존 차트 데이터 초기
      if (init) {
        // 위젯 데이터 초기화
        this.widgetData = []

        // Series 초기화
        this.$refs.chartInstance.clear()
      }

      // API 호출
      const res = await this.getWidgetData(_.assign({
        widgetType: 'fw_allow_rule_top'
      }, contentsOptions))

      // Series 데이터 구성
      if (res.code === 'ok') {
        // restData 넣기
        this.restData = res.result
        // widgetData에 result 값만 넣기
        this.widgetData = this.restData.result
      }

      // Progress 출력 여부
      this.showProgress(false)
    }
  },
  watch: {
    widgetData (value) {
      this.$nextTick(() => {
        if (!_.isArray(value)) {
          this.categories = []
          this.allowWidgetData = [[], []]
          return
        }
        // 카테고리 설정
        this.categories = value.map(({name}) => name)

        // IPv4, v6 차트 씨리즈 생성
        const v4 = []
        const v6 = []

        for (const denyData of value) {
          // IP 버전에 따라 씨리즈 분기

          if (this.opts.chartType === 'bar') {
            if (denyData.type === 101) {
              v4.push(denyData.value)
              v6.push(0)
            } else {
              v4.push(0)
              v6.push(denyData.value)
            }
          } else {
            if (denyData.type === 101) {
              v4.push(denyData.value)
              v6.push(0)
            } else {
              v4.push(0)
              v6.push(denyData.value)
            }
          }
        }
        // 차트에 씨리즈 적용
        this.allowWidgetData = [v4, v6]
      })
    }
  }
}
</script>

<style scoped>
</style>
